import { useDispatch } from 'react-redux';
import { isUploadAvatarData } from '@anm/components/form/UserAvatarInput';
import { TeamFormFields } from '@anm/components/team/TeamForm';
import { teamActions } from '../../../../store/modules/team';

const useSubmit = () => {
  const dispatch = useDispatch();

  const handleSubmit = ({ avatar, ...otherFields }: TeamFormFields) => {
    dispatch(
      teamActions.updateTeam({
        ...(avatar && isUploadAvatarData(avatar) && { avatar: avatar.file }),
        ...otherFields
      })
    );
  };

  return handleSubmit;
};

export default useSubmit;
